import { ConnectionPool, setConnectionPool } from "../core/connectionPool";
import { defaultSdkConfig, SdkConfig } from "./config";
import { Cache } from "../ops/dataOps/cache";
import { response } from "../proto/bundle";

export const globalCache = new Cache();

export let initInProgress = false;
let navigateFn: ((path: string) => void) | null = null;


export async function sdkInit(config: SdkConfig = {}) {

    if (initInProgress) {
        return;
    }
    initInProgress = true;
    try {
        const resolved = {
            ...defaultSdkConfig,
            ...config,
        };
        if (resolved.poolSize < 1) {
            throw new Error("A minimum of 1 connection required in the pool");
        }
        const pool = new ConnectionPool({
            url: resolved.wsUrl,
            poolSize: resolved.poolSize,
            reconnectDelayMs: resolved.reconnectDelayMs,
        });
        await pool.getAvailableConnection();
        console.log(`[Pool] Connection pool initialized (1/${resolved.poolSize} connections ready, rest will connect on setPin)`);
        setConnectionPool(pool);
        globalCache.clear();
    } finally {
        initInProgress = false;
    }
}

export function importNavigateFn(navigate: (path: string) => void) {
  navigateFn = navigate;
}

export function goTo(path: string) {
  if (!navigateFn) {
    throw new Error("Navigator not set");
  }
  navigateFn(path);
}

export function checkMigrate(
  status?: response.Status | null
) {
  switch (status) {
    case response.Status.BYOS_MIGRATION_IN_PROGRESS:
      goTo("/migrate")
      return
  
    default:
      return
  }
}